var map = {
	"./bg145.jpg": 64221,
	"./br/PT/S1/bg145.jpg": 70961,
	"./in/EN/S1/bg145.jpg": 28814,
	"./ph/EN/S1/bg145.jpg": 64908,
	"./vn/VI/S1/bg145.jpg": 95253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82671;